import { r as registerInstance, h, g as getElement } from './index-41410303.js';
import { H as HtmlUtil } from './html-util-2802b0f8.js';
import { E as EventService, a as MessageCode, M as MessageType } from './event-service-b352bb3b.js';
import { I as InternalEventType } from './internal-event-types-8598fbfb.js';
import './internal-download-as-event-b0b1e7d3.js';
import './internal-dropdown-value-selected-event-310f527b.js';

const explainPlanCss = ":host{display:block}.explain-plan-copy-btn{float:right;color:#003663;border:1px solid #F2F2F2;background-color:#F2F2F2;font-weight:400;line-height:18px;cursor:pointer}";

const ExplainPlan = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.binding = undefined;
    this.forHtml = true;
    this.translationService = undefined;
  }
  getStringRepresentation() {
    var _a, _b;
    const value = (_b = (_a = this.binding) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    return HtmlUtil.escapeHTMLEntities(value);
  }
  onCopy() {
    const text = this.getStringRepresentation();
    this.copyToClipboard(text);
  }
  /**
   * Copy the provided text to the clipboard.
   * Uses `navigator.clipboard.writeText` when available, otherwise falls back to a textarea + `execCommand('copy')`.
   * Emits an internal notification event on successful copy.
   * @param text - text to copy
   * @public
   */
  copyToClipboard(text) {
    var _a;
    if (!text) {
      return;
    }
    const resourceCopiedMessage = this.translationService.translate('yasr.explain_plan.copied_success');
    if ((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) {
      void navigator.clipboard.writeText(text)
        .then(() => {
        EventService.emitFromInnerElement(this.hostElement, InternalEventType.INTERNAL_NOTIFICATION_MESSAGE_EVENT, { code: MessageCode.EXPLAIN_PLAN_COPIED_SUCCESSFULLY, messageType: MessageType.SUCCESS, message: resourceCopiedMessage });
      })
        .catch((err) => {
        console.error('Could not copy explain plan: ', err);
      });
      return;
    }
    // Fallback
    const textAreaElement = document.createElement('textarea');
    textAreaElement.value = text;
    textAreaElement.setAttribute('readonly', '');
    textAreaElement.style.position = 'absolute';
    textAreaElement.style.left = '-9999px';
    document.body.appendChild(textAreaElement);
    textAreaElement.select();
    try {
      const ok = document.execCommand('copy');
      if (ok) {
        EventService.emitFromInnerElement(this.hostElement, InternalEventType.INTERNAL_NOTIFICATION_MESSAGE_EVENT, { code: MessageCode.EXPLAIN_PLAN_COPIED_SUCCESSFULLY, messageType: MessageType.SUCCESS, message: resourceCopiedMessage });
      }
      else {
        console.error('Could not copy explain plan');
      }
    }
    catch (err) {
      console.error('Could not copy explain plan: ', err);
    }
    document.body.removeChild(textAreaElement);
  }
  /**
   * Render the component template.
   * Shows a copy button and the explain-plan content (HTML or plain string depending on `forHtml`).
   * @public
   */
  render() {
    const stringRepresentation = this.getStringRepresentation();
    if (!this.forHtml) {
      const asString = stringRepresentation.startsWith('"') ? stringRepresentation : `"${stringRepresentation}"`;
      return h("div", null, asString);
    }
    const copyLabel = this.translationService.translate('yasr.explain_plan.copy_button.label');
    return (h("div", { class: "yasr-explain-plan-component" }, h("button", { class: "explain-plan-copy-btn", type: "button", onClick: () => this.onCopy() }, copyLabel), h("div", { class: "explain-plan-container" }, h("div", { class: "cm-s-default explainPlanQuery", innerHTML: stringRepresentation }))));
  }
  get hostElement() { return getElement(this); }
};
ExplainPlan.style = explainPlanCss;

export { ExplainPlan as ontotext_explain_plan };
